<template >
  <div id="container" class="container" v-wechat-title="'交易通知订阅'">
    <!-- dom二维码 -->
    <div id="qr-code" class="qr-code">
      <div ref="qrCodeDiv" />
    </div>
    <!-- 图片二维码 -->
    <img class="qr-code-img" :src="qrCodeBase64" :show-menu-by-longpress="true" alt="">
    <!-- 提示信息 -->
    <div class="tips">
      提示：长按上方二维码图片， 在弹出菜单中选择”前往图中包含的公众号“，在打开页面中点击”关注公众号“按钮，完成微信公众号的关注
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import html2canvas from 'html2canvas';
import { GetOAQRCode } from '@/api/weChat';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

export default {
  name: 'OfficialQrCode',
  data() {
    return {
      qrCodeBase64: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getOAQRCode(() => {
        // 2023.2.20修改，原因如下：
        // 由于直接用DOM二维码，部分安卓手机无法使用长按图片关注功能
        // 修改为用html2canvas将DOM转换为base64，将base64编码赋值给一个img元素的src属性
        // 并在img的html节点中加入:show-menu-by-longpress="true"属性
        // 即可实现由img显示二维码，这样可以在大部分安卓手机上实现长按图片关注功能
        html2canvas(document.querySelector('#qr-code')).then(canvas => {
          // 1.将DOM转换为base64
          this.qrCodeBase64 = canvas.toDataURL('image/png');
          // 2.将DOM中原二维码元素删除掉
          const container = document.getElementById('container');
          const qr_code = document.getElementById('qr-code');
          container.removeChild(qr_code);
        });
      });
    });
  },
  methods: {
    getOAQRCode(callback = null) {
      CusLoadingOpen();
      GetOAQRCode()
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              // 用qrcode生产dom二维码
              new QRCode(this.$refs.qrCodeDiv, {
                text: decodeURIComponent(res.data.url),
                width: 250,
                height: 250,
                colorDark: '#000',
                colorLight: '#fff',
                correctLevel: QRCode.CorrectLevel.L,
              });
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message || err.msg);
          msg && CusToast(msg);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  line-height: 1;

  .qr-code {
    width: 100%;
    height: 15rem;
    background-color: #fff;
    margin: 1rem 0 0 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .qr-code-img {
    width: 100%;
    margin: 1rem 0 0 0;
  }

  .tips {
    width: 100%;
    line-height: 1.5;
    background-color: #fff;
    padding: 1rem;
    margin: 1rem 0 0 0;
    text-align: justify;
    font-size: 0.9rem;
    color: #226aa5;
  }
}
</style>
